<script setup>
import InvitationForm from '@/components/invitations/outside/InvitationForm.vue';

</script>

<template>
    <div if="!userKey.value">
        <InvitationForm />
    </div>
</template>